module.exports = __webpack_public_path__ + "img/FamilyBG.64300c5a.jpg";